// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2ppw1","errorLogs":"EditorFooter_errorLogs__3bmnC"};